import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

import "bulma/css/bulma.css";


createApp(App).mount("#app");
